export default __webpack_public_path__ + "static/media/close-eye.9db6e10c.svg";